/**
 * @file CarrierQuoteCalculator.tsx
 * @description Справочный калькулятор доставки в настройках перевозчика
 * (phase19.12 шаг 5).
 *
 * Тот же расчёт, что в карточке заказа, но без применения к отгрузке: нужен,
 * чтобы проверить настройки («а сколько выйдет коробка 1 кг до Москвы?») сразу
 * после правки наценки и точки отправления. Позиций заказа тут нет — места
 * заполняются руками.
 */

import { useMemo } from "react";

import { DeliveryQuoteForm } from "./DeliveryQuoteForm";
import { DeliveryQuoteResultPanel } from "./DeliveryQuoteResultPanel";
import { useDeliveryQuote } from "./useDeliveryQuote";
import { emptyQuoteForm } from "../../lib/delivery-quote";
import type { CarrierKind } from "../../lib/api-shop-carriers";

interface Props {
  carrier: CarrierKind;
  /** Ссылка на эту же страницу настроек — для действий из причин отказа. */
  carrierSettingsHref?: string | null;
}

export function CarrierQuoteCalculator({ carrier, carrierSettingsHref }: Props) {
  const initial = useMemo(() => emptyQuoteForm(), []);
  const controller = useDeliveryQuote({ carrier, initial });

  return (
    <div className="flex flex-col gap-4">
      <div>
        <div className="text-sm font-semibold">Проверить расчёт</div>
        <p className="text-xs text-on-surface-variant">
          Живой запрос к перевозчику с текущими настройками. Ничего не сохраняет — только
          показывает, что увидит клиент.
        </p>
      </div>

      <DeliveryQuoteForm
        value={controller.value}
        onChange={controller.patch}
        running={controller.running}
        onRun={() => void controller.run()}
      />

      <DeliveryQuoteResultPanel
        controller={controller}
        carrierSettingsHref={carrierSettingsHref}
      />
    </div>
  );
}
